export const SESSION_KEY: string = 'CHECKOUT_FORM'
export const ENV: string = process.env.VITE_ENV || 'local'
export const DEFAULT_LOCALE: string = process.env.VITE_LOCALE || 'de'

// import.meta envs
export const API_ENTRYPOINT: string = process.env.VITE_API_ENTRYPOINT || 'https://*.probatix.de'
export const MY_PROBATIX_URL: string = process.env.VITE_MY_PROBATIX_URL || 'http://probatix.localhost:4000'
export const SENTRY_DSN: string = process.env.VITE_SENTRY_DSN || ''

export const API_MY_PROBATIX_ENTRYPOINT: string =
process.env.VITE_CORE_API_ENTRYPOINT ?
  (`${process.env.VITE_CORE_API_ENTRYPOINT}/api`) :
  'http://probatix.localhost:8000/api'
export const GIT_VERSION: string = process.env.VITE_GIT_VERSION || 'v999.99-dev'
